import { Formik } from 'formik';
import React from 'react';
import styled from 'styled-components';
import * as Yup from 'yup';

import {
  Button,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Link,
  TextField,
  Typography,
  useMediaQuery
} from '@material-ui/core';

import logo from '../assets/logo';
import RecaptchaLegal from '../common/RecaptchaLegal';
import { useRemoveJiraWidget } from '../common/useRemoveJiraWidget';
import { useRegisterUser } from '../user/User.hooks';
import * as Styled from './Login.styled';

export const StyledSignupContainer = styled.div`
  overflow: auto !important;
  font: 300 16px "Helvetica Neue";
  .sign-up {
    z-index: 3;
    overflow: auto;
    max-width: 480px;
    min-width: 320px;
    padding: 24px;
    border-radius: 10px;
    // width: 100%;
    // height: calc(100% - 48px);
    max-height: 800px;
    min-height: 690px;
    .error {
      margin: 0 0 12px 0;
    }
    @media only screen and (max-width: 1000px) {
      margin: 12px auto;
    }
  }
  .forgot-password-link {
    text-align: center;
    max-width: 180px;
    font-weight: 500;
    font-size: 14px;
  }

  .flex-row {
    display: flex;
  }
  .split {
    flex: 1;
  }
  h1 {
    font-weight: 300;
  }

  section#introduction {
    max-width: 100%;
    text-align: center;
    overflow: hidden;
    background-color: #1D2536;
    background-image: url('https://www.sierralabs.com/quality-management/images/bg-stars.jpg');
    background-position: no-repeat center top;
    background-size: cover;

    .form {
      width: 33%;
      padding: 60px 0 32px;
    }
    .qms img {
      width: 141px;
    }
    .flex-row {
      position: relative;
      margin: auto;
      max-width: 1440px;
    }
    .content {
      padding: 98px 64px 64px 50px;
    }
    .container {
      max-width: 600px;
      margin: 0 auto;
    }
    .dashboard {
      position: absolute;
      bottom: 0;
      margin-bottom: -8px;
      img {
        width: 600px;
      }
    }
    header {
      position: relative;
      color: #fff;
      text-align: left;
      .header-content {
        position: relative;
        z-index: 2;
      }
      h1 {
        /* padding-top: 30px; */
        font-size: 50px;
        line-height: 1.3em;
      }
      .header-description {
        font-size: 20px;
        line-height: 32px;
      }
    }
    a.download {
      margin-top: 30px;
    }
    .abstract {
      position: absolute;
      top: -116px;
      left: 84px;
      mix-blend-mode: color-dodge;
      z-index: 1;
    }
    @media only screen and (max-width: 1000px) {
      .flex-row {
        flex-direction: column;
      }
      .form {
        width: auto;
        padding: 0;
      }
      .content {
        order: 0;
        padding: 64px 24px 32px 24px;
      }
      .container {
        max-width: 100%;
      }
      .dashboard {
        display: none;
      }
      header {
        text-align: center;
        margin: 12px auto 0 auto;
        max-width: 640px;
      }
      .abstract {
        top: -110px;
        left: calc(50% - 196px)
        /* margin-left: -246px; */
        /* top: 64px; */
        /* left: 50%; */
        /* right: inherit; */
      }
      .dashboard {
        position: unset;
        margin-bottom: -110px;
      }
      h1, p {
        margin-left: 30px;
        margin-right: 30px;
      }
    }
    @media only screen and (max-width: 640px) {
      .content {
        padding: 64px 12px 32px 12px;
      }
      header {
        h1 {
          font-size: 34px;
        }
      }
    }
  }

  section#market {
    background: #d0e5ff url("https://www.sierralabs.com/images/atom.png") no-repeat center border-box;
    background-size: 800px 800px;
    .rect {
      position: absolute;
      width: 710px;
      height: 200px;
      color: #83b5d6;
    }
    .flex-row {
      padding-top: 100px;
      margin: 0 auto;
      max-width: 1300px;
    }
    .split {
      text-align: left;
      z-index: 1;
    }
    .screenshot {
      display: flex;
      flex: 1.5;
      padding: 0 64px 64px 0;
      max-width: 917px;
      justify-content: flex-end;
      overflow: hidden;
    }
    header {
      margin: 90px 64px 0 0;
      max-width: 440px;
      z-index: 1;
      h1 {
        color: #b61f24;
        font-size: 42px;
      }
      p {
        color: #000;
        font-size: 17px;
        font-weight: 400;
      }
    }
    @media only screen and (max-width: 1280px) {
      h1 {
        font-size: 46px;
        line-height: 54px;
      }
    }
    @media only screen and (max-width: 852px) {
      header {
        margin-top: 64px;
      }
    }
    @media only screen and (max-width: 768px) {
      .flex-row {
        padding-top: 50px;
        flex-direction: column;
      }
      .split {
        text-align: center;
      }
      .content {
        order: 0;
      }
      .screenshot {
        order: 1;
        justify-content: center;
        max-width: inherit;
        padding: 0;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      header {
        margin: 0 auto 0 auto;
        padding: 0 16px;
      }
      .signup {
        margin-bottom: 30px;
      }
      .button {
        margin: 0 auto;
      }
    }
  }

  section#comparison {
    background: url("https://www.sierralabs.com/quality-management/images/bg-stars.jpg") no-repeat center top;
    background-size: cover;
    .atom {
      position: absolute;
      left: 350px;
      top: 100px;
    }
    .container {
      display: flex;
      z-index: 1;
      flex-direction: column;
      padding-bottom: 70px;
      overflow-x: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
    header {
      margin: auto;
      padding: 90px 0 34px 0;
      h1 {
        color: #fff;
        font-size: 42px;
      }
    }
    .signup {
      display: flex;
      padding: 20px;
      .button {
        margin: 0 auto;
      }
      .external {
        background-color: #B61F24;
      }
    }
    .comparison {
      margin: auto;
      justify-content: center;
      z-index: 2;
      table {
        margin: 0 24px;
        padding: 60px;
        background-color: #fff;
        border-spacing: 0px;
        border-radius: 8px;
        color: #03101F;
        .black {
          color: #000;
        }
        .whitebg {
          background-color: #fff;
        }
        .rtborder {
          border-right: 1px dashed #979797;
        }
        th, td {
          background-color: #FAFAFA;
          border-bottom: 1px solid #BCC2C5;
          min-width: 100px;
        }
        th {
          text-align: left;
          color: #B61F24;
          font: 16px "Helvetica Neue", Helvetica, sans-serif;
          font-weight: 500;
          line-height: 25px;
          padding: 11px 16px;
        }
        td {
          text-align: center;
          padding: 11px;
        }
      }
    }
    @media only screen and (max-width: 1280px) {
      h1 {
        font-size: 46px;
        line-height: 54px;
      }
    }
    @media only screen and (max-width: 852px) {
      header {
        margin: 64px auto 32px auto;
        padding: 0 16px;
      }
      h1 {
        text-align: center;
      }
      .comparison table {
        padding: 32px;
        th, td {
          font-size: 14px;
          min-width: 50px !important;
        }
        td {
          padding: 5px !important;
        }
      }
    }
  }

  section#sierralabs {
    background: #ffffff url("https://www.sierralabs.com/images/atom.png") fixed no-repeat top border-box;
    background-size: 700px 700px;
    overflow: hidden;
    display: block;
    padding-top: 75px;
    .flex-row {
      padding-left: 30px;
      padding-top: 25px;
      margin: 0 auto;
      align-items: center;
      max-width: 1300px;
    }
    .item {
      padding: 0 32px;
    }
    h1 {
      font-size: 30px;
      line-height: 30px;
      color: rgba(182, 31, 36, 0.5);
      padding: 12px 0;
    }
    p {
      color: #000;
      display: none;
    }
    .active-item {
      border-left: 2px solid #EC2027;
      margin: 12px auto 0 auto;
      min-width: 375px;
      max-width: 500px;
      h1 {
        padding-top: 0 !important;
        color: rgba(182, 31, 36, 1);
      }
      p {
        display: block;
        padding-top: 12px;
      }
    }
    .active-image {
      display: flex;
      img {
        max-height: 75vh;
        max-width: 75vw;
      }
    }
    @media only screen and (max-width: 1000px) {
      .flex-row {
        flex-direction: column;
      }
    }
    @media only screen and (max-width: 852px) {
      padding-top: 50px;
      .flex-row {
        padding-left: 50px;
      }
      .active-image img {
        max-width: 60vw;
      }
    }
    @media only screen and (max-width: 768px) {
      .active-image img {
        max-width: 95vw;
      }
    }
    @media only screen and (max-width: 490px) {
      .active-item {
        min-width: auto;
      }
      .active-image img {
        width: 300px;
        height: auto;
      }
    }
  }

  section#integration {
    background-color: #fff;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    padding: 5% 4%;
    .flex-row {
      padding: 72px 0;
      margin: 0 auto;
      // max-width: 1300px;
    }
    .partner-logos {
      flex: 1.4;
    }
    ul.logo-wall {
      display: block;
      list-style: none;
      padding: 0 30px;
      margin: 0;
      max-width: 1440px;
      li {
        display: inline-block;
        vertical-align: top;
        .logo {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 160px;
          height: 100px;
        }
      }
    }
    .content-container {
      max-width: 456px;
    }
    .signup {
      display: flex;
    }
    .external {
      background-color: #B61F24;
    }
    h1 {
      font-size: 46px;
      padding-top: 24px;
      margin: auto;
    }
    h3 {
      margin-top: 0;
    }
    .description {
      margin: 16px 0 46px 0;
    }
    ul.list {
      list-style: none;
      padding: 0;
      margin: 0;
      max-width: 364px;
      li {
        display: inline-block;
        vertical-align: top;
        padding-left: 60px;
        padding-bottom: 20px;
        &.integration {
          background: url("https://www.sierralabs.com/images/icon-integration-red.svg") no-repeat;
        }
        &.add-partner {
          background: url("https://www.sierralabs.com/images/icon-add-partner-red.svg") no-repeat;
        }
      }
    }
    @media only screen and (min-width: 1500px) {
      .content-container {
        max-width: inherit;
        padding-right: 96px;
      }
      ul.list {
        max-width: inherit;
      }
    }
    @media only screen and (max-width: 1268px) {
      ul.logo-wall {
        padding: 0 20px;
        li .logo {
          width: 120px;
        }
      }
    }
    @media only screen and (max-width: 1165px) {
      .content-container {
        max-width: inherit;
        padding-right: 64px;
      }
    }
    @media only screen and (max-width: 994px) {
      ul.logo-wall li .logo {
        width: 100px;
      }
    }
    @media only screen and (max-width: 823px) {
      .flex-row {
        padding: 64px 0;
      }
      .content-container {
        padding-right: 34px;
      }
      ul.logo-wall li .logo {
        width: 120px;
      }
    }
    @media only screen and (max-width: 768px) {
      text-align: center;
      flex-direction: column;
      .flex-row {
        padding: 0;
        flex-direction: column;
      }
      ul.logo-wall {
        padding-bottom: 48px;
        li .logo {
          width: 140px;
        }
      }
      .content-container {
        margin: 0 auto;
        padding: 30px;
        max-width: 480px;
      }
      ul.list {
        margin: 34px auto 0 auto;
        text-align: left;
      }
      .signup {
        margin: 0 auto;
      }
    }
  }

  section#partners {
    background: #d0e5ff url("https://www.sierralabs.com/images/atom.png") no-repeat top border-box;
    background-size: 800px 800px;
    overflow: hidden;
    text-align: center;
    padding: 5% 4%;
    .external {
      background-color: #B61F24;
    }
    img.half-scale {
      transform: scale(0.5);
    }
    h1 {
      font-size: 46px;
      line-height: 54px;
    }
    h2 {
      padding: 64px 30px 17px 30px;
      font-size: 20px;
    }
    .trial-button {
      padding: 15px 0 60px 0;
    }
    ul {
      display: block;
      list-style: none;
      padding: 0 60px 72px 60px;
      margin: 0 auto;
      max-width: 1355px;
      li {
        display: inline-block;
        vertical-align: top;
        margin: 5px;
        .logo-card {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;
          width: 220px;
          height: 144px;
          opacity: 0.6;
          border-radius: 16px;
          &:hover
            opacity: 1.0;
        }
      }
    }
    @media only screen and (max-width: 809px) {
      ul {
        padding: 0 30px 64px 30px;
      }
    }
    @media only screen and (max-width: 768px) {
      ul {
        padding: 0 20px 64px 20px;
        li .logo-card {
          width: 180px;
          height: 100px;
        }
      }
      img {
        &:not(.half-scale) {
          transform: scale(0.75);
        }
        &.half-scale {
          transform: scale(0.375); // 0.75 * 0.5
        }
      }
    }
    @media only screen and (max-width: 419px) {
      ul {
        padding: 0 10px 30px 10px;
        li .logo-card {
          width: 130px;
          height: 80px;
        }
      }
      img {
        &:not(.half-scale) {
          transform: scale(0.5);
        }
        &.half-scale {
          transform: scale(0.25); // 0.5 * 0.5
        }
      }
    }
  }

`;

export const StyledButton = styled(Button)`
  background-color: #b61f24;
  border-radius: 23px;
  padding: 12px 24px;
  font-size: 14px;
  line-height: 20px;
  color: #fff;
  border: none;
  text-transform: none;
`;

const passwordMinLength = 8;
const passwordRegex: RegExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/;
const passwordRegexErrorMessage =
  'Need at least an uppercase and a lowercase letter, and a number.';

const loginSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required.'),
  lastName: Yup.string().required('Last name is required.'),
  company: Yup.string().required('Name of your company is required.'),
  email: Yup.string()
    .email('Invalid email address.')
    .required('Email address is required.'),
  password: Yup.string()
    .matches(passwordRegex, passwordRegexErrorMessage)
    .min(passwordMinLength, `Minimum ${passwordMinLength} characters.`),
  confirmPassword: Yup.string()
    .required('Please confirm the password')
    .when('password', {
      is: (value: any) => value && value.length > 0,
      then: Yup.string().oneOf(
        [Yup.ref('password')],
        'Confirm password must match.'
      )
    }),
  terms: Yup.boolean().oneOf(
    [true],
    'Please agree to the terms and conditions.'
  )
});

const SignUp: React.FC = () => {
  useRemoveJiraWidget();
  const { user, isLoading, error, register } = useRegisterUser();
  const success = !!user;

  function scrollToForm(e: any) {
    let form = document.getElementById('form');
    e.preventDefault(); // Stop Page Reloading
    form && form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  return (
    <StyledSignupContainer>
      <section id='introduction'>
        <div className='split flex-row'>
          <div className='split content'>
            <div className='container'>
              <div className='qms'>
                <img
                  src='https://www.sierralabs.com/free-trial/images/sierraqms-white.png'
                  alt='Sierra QMS'
                />
              </div>
              <header>
                <img
                  className='abstract'
                  src='https://www.sierralabs.com/images/abstract-intro.svg'
                  alt=''
                />
                <div className='header-content'>
                  <h1>
                    Automate Your Team’s FDA Compliance While Using The Tools
                    You Love!
                  </h1>
                  <p className='header-description'>
                    Discover how simple regulatory compliance can be when you
                    have an automated Quality Management System (QMS) that does
                    all the heavy lifting for you.
                  </p>
                </div>
              </header>
              <div className='dashboard'>
                <img
                  src='https://www.sierralabs.com/free-trial/images/admin_dashboard.png'
                  alt='Admin'
                />
              </div>
            </div>
          </div>
          <div className='form' id='form'>
            <Styled.StyledLoginCard className='sign-up'>
              <img src={logo} alt='Sierra Labs' className='logo' />
              <h2 className={success ? 'message-only' : undefined}>
                {success ? 'Account Created' : 'Free Trial Sign Up'}
              </h2>
              {!success && (
                <Formik
                  initialValues={{
                    firstName: '',
                    lastName: '',
                    company: '',
                    email: '',
                    password: '',
                    confirmPassword: '',
                    terms: false
                  }}
                  validateOnBlur
                  validateOnMount
                  validationSchema={loginSchema}
                  onSubmit={form =>
                    register({ ...form, companyName: form.company })
                  }
                >
                  {({
                    values,
                    errors,
                    touched,
                    isValid,
                    handleChange,
                    handleBlur
                  }) => (
                    <Styled.StyledLoginForm>
                      <TextField
                        variant='outlined'
                        name='firstName'
                        label='First Name'
                        className='form-field'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.firstName}
                        error={touched.firstName && !!errors.firstName}
                        helperText={touched.firstName && errors.firstName}
                      />
                      <TextField
                        variant='outlined'
                        name='lastName'
                        label='Last Name'
                        className='form-field'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.lastName}
                        error={touched.lastName && !!errors.lastName}
                        helperText={touched.lastName && errors.lastName}
                      />
                      <TextField
                        variant='outlined'
                        name='company'
                        label='Company Name'
                        className='form-field'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.company}
                        error={touched.company && !!errors.company}
                        helperText={touched.company && errors.company}
                      />
                      <TextField
                        variant='outlined'
                        type='email'
                        name='email'
                        label='Email'
                        className='form-field'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email}
                        error={touched.email && !!errors.email}
                        helperText={touched.email && errors.email}
                      />
                      <TextField
                        variant='outlined'
                        type='password'
                        name='password'
                        label='Password'
                        className='form-field'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.password}
                        error={touched.password && !!errors.password}
                        helperText={touched.password && errors.password}
                      />
                      <TextField
                        variant='outlined'
                        type='password'
                        name='confirmPassword'
                        label='Confirm Password'
                        className='form-field'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.confirmPassword}
                        error={
                          touched.confirmPassword && !!errors.confirmPassword
                        }
                        helperText={
                          touched.confirmPassword && errors.confirmPassword
                        }
                      />
                      <FormControlLabel
                        className='form-field'
                        label={
                          <div className='legal'>
                            I accept the{' '}
                            <a
                              href='https://policies.sierralabs.com/legal/terms-conditions'
                              target='_blank'
                              rel='noreferrer'
                            >
                              Terms and Conditions
                            </a>
                          </div>
                        }
                        control={
                          <Checkbox
                            name='terms'
                            color='primary'
                            className='checkbox'
                            checked={values.terms}
                            onChange={handleChange}
                          />
                        }
                      />
                      {!isLoading && error && (
                        <p className='error'>{error.message}</p>
                      )}
                      <Button
                        type='submit'
                        variant='contained'
                        disableElevation
                        disabled={!isValid || isLoading}
                        endIcon={isLoading && <CircularProgress size={16} />}
                      >
                        Create Account
                      </Button>
                      <RecaptchaLegal style={{ marginTop: 10 }} />
                    </Styled.StyledLoginForm>
                  )}
                </Formik>
              )}

              {user && (
                <Styled.StyledLoginCardContent>
                  <Typography variant='body1'>
                    Your account has been successfully created!
                  </Typography>
                  <Typography variant='body1'>
                    Please check your email address (
                    {<strong>{user.email}</strong>}) to verify your account in
                    order to login.
                  </Typography>
                </Styled.StyledLoginCardContent>
              )}

              <Link className='forgot-password-link' href='/login'>
                {success
                  ? 'Proceed to Login'
                  : 'Already have an account? Click here to login.'}
              </Link>
            </Styled.StyledLoginCard>
          </div>
        </div>
      </section>
      <section id='market'>
        <div className='flex-row'>
          <div className='split screenshot'>
            <img
              src='https://www.sierralabs.com/images/home-hero-screenshot.png'
              width='710'
              height='533'
              alt='Sierra Labs Dashboard'
            />
          </div>
          <div className='split content'>
            <header>
              <h1>Accelerate Your Time to Market and Scale Successfully</h1>
              <p>
                Finally, a QMS that is customized just for your team that will
                automate your regulatory compliance and drive your innovations.
              </p>
            </header>
            <StyledButton className='signup' onClick={e => scrollToForm(e)}>
              Start Free Trial
            </StyledButton>
          </div>
        </div>
      </section>
      <section id='comparison'>
        <div className='container'>
          <header>
            <h1>Why Choose Sierra QMS Over the Rest?</h1>
          </header>
          <div className='comparison'>
            <table>
              <tr>
                <th className='black whitebg'>Company</th>
                <td className='whitebg rtborder'>
                  <img
                    src='https://www.sierralabs.com/images/sierra-labs-icon.svg'
                    alt='Sierra Labs'
                    height='27'
                  />
                </td>
                <th className='black whitebg' colSpan={2}>
                  The Others...
                </th>
                <td className='whitebg'></td>
              </tr>
              <tr>
                <th className='black'>Price</th>
                <td className='whitebg rtborder'>$$</td>
                <td>$</td>
                <td>$$</td>
                <td>$$$</td>
              </tr>
              <tr>
                <th>Document Management</th>
                <td className='whitebg rtborder'>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
              </tr>
              <tr>
                <th>Training</th>
                <td className='whitebg rtborder'>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
              </tr>
              <tr>
                <th>Audit/ Supplier Management</th>
                <td className='whitebg rtborder'>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
              </tr>
              <tr>
                <th>Traceability</th>
                <td className='whitebg rtborder'>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
              </tr>
              <tr>
                <th>Starter Package (Policies/Templates)</th>
                <td className='whitebg rtborder'>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
              </tr>
              <tr>
                <th>Publishing</th>
                <td className='whitebg rtborder'>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
              </tr>
              <tr>
                <th>Tool Integrations</th>
                <td className='whitebg rtborder'>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
              </tr>
              <tr>
                <th>Quality Roadmap (HITRUST/SOC2)</th>
                <td className='whitebg rtborder'>
                  <img
                    src='https://www.sierralabs.com/images/icon-check-mark.svg'
                    height='20'
                    alt='check'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
                <td>
                  <img
                    src='https://www.sierralabs.com/images/icon-x-mark.svg'
                    height='20'
                    alt='x'
                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </section>
      <section id='sierralabs'>
        <div className='flex-row row-1'>
          <div className='split'>
            <div className='item active-item'>
              <h1>Planning a Quality Roadmap</h1>
              <p>
                Strategically map out your quality journey, ensuring you reach
                each of your compliance milestones in your desired timeframes.
                Let’s take the stress out of Approvals, Certifications, and
                Audits with an actionable, step-by-step implementation plan.
              </p>
              <StyledButton className='signup' onClick={e => scrollToForm(e)}>
                See It In Action
              </StyledButton>
            </div>
          </div>
          <div className='split'>
            <div className='active-image'>
              <img
                src='https://www.sierralabs.com/free-trial/images/quality-roadmap.png'
                id='sierra-labs-active'
                alt='quality roadmap'
              />
            </div>
          </div>
        </div>
        <div className='flex-row row-2'>
          <div className='split'>
            <div className='item active-item'>
              <h1>Audit Management</h1>
              <p>
                Effortlessly track your test findings, tasks, and action items
                to prepare for any and all future audits. Sierra QMS allows you
                to tackle audits in a systematic way with all of your data
                available at the click of a button.
              </p>
              <StyledButton className='signup' onClick={e => scrollToForm(e)}>
                See It In Action
              </StyledButton>
            </div>
          </div>
          <div className='split'>
            <div className='active-image'>
              <img
                src='https://www.sierralabs.com/free-trial/images/audit-management.png'
                id='sierra-labs-active'
                alt='audit management'
              />
            </div>
          </div>
        </div>
        <div className='flex-row row-3'>
          <div className='split'>
            <div className='item active-item'>
              <h1>Product Traceability</h1>
              <p>
                Maintain full traceability at each stage of production.
                Seamlessly track your product information and trace it
                throughout it's entire life cycle to help you easily generate
                your regulatory documentation.
              </p>
              <StyledButton className='signup' onClick={e => scrollToForm(e)}>
                See It In Action
              </StyledButton>
            </div>
          </div>
          <div className='split'>
            <div className='active-image'>
              <img
                src='https://www.sierralabs.com/free-trial/images/product-traceability.png'
                id='sierra-labs-active'
                alt='product traceability'
              />
            </div>
          </div>
        </div>
        <div className='flex-row row-4'>
          <div className='split'>
            <div className='item active-item'>
              <h1>Document Publishing</h1>
              <p>
                Publish documents for your audits, inspections, and submissions
                in a matter of seconds. Sierra QMS allows you to publish
                information from your QMS into templatized documents to share
                with regulatory bodies.
              </p>
              <StyledButton className='signup' onClick={e => scrollToForm(e)}>
                See It In Action
              </StyledButton>
            </div>
          </div>
          <div className='split'>
            <div className='active-image'>
              <img
                src='https://www.sierralabs.com/free-trial/images/document-publishing.png'
                id='sierra-labs-active'
                alt='document publishing'
              />
            </div>
          </div>
        </div>
        <div className='flex-row row-5'>
          <div className='split'>
            <div className='item active-item'>
              <h1>Training</h1>
              <p>
                Efficiently create training plans to ensure your team completes
                the necessary training requirements for compliance and always
                has access to critical documentation, such as SOPs and Policies.
              </p>
              <StyledButton className='signup' onClick={e => scrollToForm(e)}>
                See It In Action
              </StyledButton>
            </div>
          </div>
          <div className='split'>
            <div className='active-image'>
              <img
                src='https://www.sierralabs.com/free-trial/images/training.png'
                id='sierra-labs-active'
                alt='training'
              />
            </div>
          </div>
        </div>
      </section>
      <section id='integration'>
        <h1>Integrates with your favorite tools</h1>
        <div className='flex-row'>
          <div className='split content'>
            <div className='content-container'>
              <p className='description'>
                Turn your policies and procedures into actionable intelligence
                by integrating with your existing tools and make sure your team
                is doing what they are suppose to be doing.
              </p>
              <ul className='list'>
                <li className='integration'>
                  <h3>Seamless Integration</h3>
                  <p>
                    Our system can adapt to any custom workflow and process.
                  </p>
                </li>
                <li className='add-partner'>
                  <h3>Don't see the right logo?</h3>
                  <p>
                    No problem, reach out to us and we can work with you on a
                    custom integration.
                  </p>
                </li>
              </ul>
              <StyledButton className='signup' onClick={e => scrollToForm(e)}>
                Try Now
              </StyledButton>
            </div>
          </div>
          <div className='split partner-logos'>
            <ul className='logo-wall'>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/jira.png'
                    alt='Atlassian Jira'
                    width='72'
                    height='25'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/bitbucket.png'
                    alt='Atlassian Bitbucket'
                    width='98'
                    height='14'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/github.png'
                    alt='GitHub'
                    width='68'
                    height='19'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/spirateam.png'
                    alt='SpiraTeam'
                    width='97'
                    height='24'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/jama.png'
                    alt='Jama Software'
                    width='72'
                    height='22'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/gitlab.png'
                    alt='GitLab'
                    width='37'
                    height='40'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/xray.png'
                    alt='Xray Test'
                    width='34'
                    height='37'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/zephyr.png'
                    alt='Zephyr'
                    width='70'
                    height='18'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/testrail.png'
                    alt='TestRail'
                    width='68'
                    height='13'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/rspace.png'
                    alt='RSpace'
                    width='40'
                    height='49'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/asana.png'
                    alt='Asana'
                    width='62'
                    height='42'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/spiratest.png'
                    alt='SpiraTest'
                    width='90'
                    height='23'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/aws.png'
                    alt='Amazon Web Services'
                    width='84'
                    height='47'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/ibm-rational.png'
                    alt='IBM Rational'
                    width='117'
                    height='65'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/solidworks.png'
                    alt='Solidworks'
                    width='59'
                    height='31'
                  />
                </div>
              </li>
              <li>
                <div className='logo'>
                  <img
                    src='https://www.sierralabs.com/images/integration/autocad.png'
                    alt='Autodesk AutoCAD'
                    width='81'
                    height='20'
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className='light-background' id='partners'>
        <h2>Companies that trust Sierra Labs</h2>
        <ul>
          <li>
            <div className='logo-card'>
              <img
                src='https://www.sierralabs.com/images/partners/aws.png'
                alt='Amazon Web Services'
              />
            </div>
          </li>
          <li>
            <div className='logo-card'>
              <img
                src='https://www.sierralabs.com/images/partners/fit.png'
                alt='Force Impact Technologies'
              />
            </div>
          </li>
          <li>
            <div className='logo-card'>
              <img
                className='half-scale'
                src='https://www.sierralabs.com/images/partners/medrio.png'
                alt='Medrio'
              />
            </div>
          </li>
          <li>
            <div className='logo-card'>
              <img
                src='https://www.sierralabs.com/images/partners/hzb-pharma.png'
                alt='HZB Pharmaceuticals'
              />
            </div>
          </li>
          <li>
            <div className='logo-card'>
              <img
                src='https://www.sierralabs.com/images/partners/scale-health.png'
                alt='ScaleHealth'
                width='89'
                height='94'
              />
            </div>
          </li>
        </ul>
        <h1>Empower your team and simplify compliance</h1>
        <StyledButton className='signup' onClick={e => scrollToForm(e)}>
          Create Your Account Now
        </StyledButton>
      </section>
    </StyledSignupContainer>
  );
};

export default SignUp;
